import { useMemo } from 'react';
import { Loader2, XCircle } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '@/app/store/store';
import { posApprovalBuild } from '../../config/posApproval.build';
import { usePosApprovalService } from '../hooks/usePosApproval';
import { PendingScreen } from '../components/PendingScreen';
import { StatusFeedbackScreen } from '../components/ApprovalStatusView';

export default function LoginApprovalFlow() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('q') || undefined;

  const dispatch = useAppDispatch();
  const { service } = useMemo(() => posApprovalBuild(dispatch), [dispatch]);

  const { approvalData, isLoading, isError, handleApprovalAction } = usePosApprovalService({ service, code: id });

  if (isLoading) {
    return (
      <div className="min-h-screen bg-white sm:bg-[#4A4A4A] flex items-center justify-center font-sans">
        <Loader2 className="w-10 h-10 animate-spin text-[#011E37] sm:text-white" />
      </div>
    );
  }

  if (isError || !approvalData) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white sm:bg-[#4A4A4A]">
        <div className="bg-white p-6 rounded-md shadow-lg text-center">
          <XCircle className="w-12 h-12 text-[#C82020] mx-auto mb-4" />
          <p className="text-[#314158] font-medium">Invalid or missing approval link.</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {approvalData.status === 'PENDING' ? (
        <PendingScreen
          details={{
            store: approvalData.storeName,
            requestedAt: approvalData.requestedAt,
            validTill: approvalData.expiresAt
          }}
          onAction={handleApprovalAction}
        />
      ) : (
        <StatusFeedbackScreen status={approvalData.status} />
      )}
    </>
  );
}
